import Modal from '@components/Modal';
import Button from '@components/Button';
import TextField from '@components/TextField';
import Select from '@components/Select';
import { apiClient } from '@services/api';
import { useState, useEffect, useRef } from 'react';
import { useHistory } from "react-router-dom";
import Icon from '@material-ui/core/Icon';

const CreateRegionModal = (props) => {
  const [region, setRegion] = useState("");
  const [regionId, setRegionId] = useState("");
  const [regions, setRegions] = useState([]);
  const history = useHistory();
  let ref = useRef(null);

  useEffect(() => {
    apiClient.httpInstance.get('/regions').then(response => {
      if (response.status === 200) {
        setRegions(response.data);
      }
    });
  }, []);

  const handleSubmit = (e, goToDetail = false) => {
    e.preventDefault();
    apiClient.httpInstance.post("/translados", {
      region_name: region,
      region_id: regionId || null,
      status: true
    })
    .then(response => {
      if (response.status === 200 || response.status === 201) {
        ref.current.click();

        if (goToDetail) {
          history.push(`/admin/traslados/detalhe/${response.data.id}`);
        }
      }
    })
  }

  return <Modal open={props.open} close={props.close}>
    <div className="flex justify-between">
      <span>Nova zona</span>
      <Icon ref={ref} className="cursor-pointer" onClick={props.close}>close</Icon>
    </div>
    <div className="mt-3">
      <TextField
        className="inputRounded"
        placeholder="Digite o nome da zona"
        variant="outlined"
        type="text"
        name="region"
        value={region}
        onChange={(e) => setRegion(e.target.value)}
        required />
      <div className="mt-3">
        <Select
          label="Região"
          name="region_id"
          value={regionId}
          onChange={(e) => setRegionId(e.target.value)}
          items={{
            field: { value: 'id', text: 'name' },
            data: regions
          }}
        />
      </div>
      <Button
        textcolor="#fff"
        padding="6px 15px"
        margintop="15px"
        customcolor={props.theme.color}
        onClick={(e) => handleSubmit(e)}>
          Salvar e continuar
      </Button>
      <Button
        textcolor={process.env.REACT_APP_SECONDARY_COLOR}
        padding="6px 15px"
        margintop="8px"
        variant="outlined"
        bgColor="transparent"
        onClick={(e) => handleSubmit(e, true)}>
          Salvar e ver detalhes
      </Button>
    </div>
  </Modal>
}

export default CreateRegionModal;
